// src/components/machineList3.js
import React, { useEffect, useState } from "react";
import { getMachinesByProduct } from "../api";

const MachinesList3 = ({ id_c, id_prod, onSelect }) => {
  const [machines, setMachines] = useState([]);

  useEffect(() => {
    const fetchMachines = async () => {
      if (id_prod) {
        const data = await getMachinesByProduct(id_c, id_prod);
        setMachines(data.machines);
      } else {
        setMachines([]); // limpia si no hay producto
      }
    };
    fetchMachines();
  }, [id_c, id_prod]);

  return (
    <select
      className="input1"
      onChange={(e) => onSelect(e.target.value)}
      required
      disabled={!id_prod}
    >
      <option value="">
        {id_prod ? "-- Selecciona una máquina --" : "-- Selecciona un producto primero --"}
      </option>
      {machines.map((m) => (
        <option key={m.cod_maq} value={m.cod_maq}>
          {m.cod_maq}
        </option>
      ))}
    </select>
  );
};

export default MachinesList3;
